<template>

<hic-list-page title="中草药禁忌管理" keyword-placeholder="名称" :entities="entities" :condition="condition" @ok="page" @load="page" :loading="meta.loading" ref="listPage">
  <template slot="buttons">
    <el-button v-if="permission.masterdata_tabu_create" type="primary" @click="create" size="small">
            <i class="el-icon-plus"></i> 新建
          </el-button>
    </template>

    <el-table-column label="操作" width="150" align="center" key="action">
          <template slot-scope="scope">
            <el-button v-if="permission.masterdata_tabu_edit && scope.row.id" type="primary" icon="el-icon-edit" title="编辑" size="mini" @click="edit(scope.row)" circle plain />
            <hic-regret-button v-if="permission.masterdata_tabu_delete && scope.row.id" type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
            <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="药品名称" prop="name" min-width="50" align="center" key="name" sortable="custom">
          <template slot-scope="{row}">
            <b>{{row.name}}</b>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="type" min-width="100" key="type" align="center" sortable="custom">
          <template slot-scope="{row}">
            <b>{{row.type}}</b>
          </template>
        </el-table-column>
        <el-table-column label="禁忌药品名称" prop="otherName" min-width="100" align="center" key="otherName" />
        <!-- <el-table-column label="创建人" prop="createUserName" min-width="100" align="center" key="createUserName" /> -->
        <el-table-column label="备注" prop="memo" show-overflow-tooltip key="memo" />

        <frequency-editor v-if="showEditor" v-model="entity" :visible.sync="showEditor" @ok="entityUpdated" />
   

  </hic-list-page>

</template>

<script>
import api from "./api";
import store from "@/common/store"
import {
  mapGetters
} from "sw-hic";
export default {
  beforeRouteEnter (to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (!store.getters.permission.masterdata_tabu_query) {
      next({
        name: 'err',
        params: { err: this.$cfg.errs.NeedPromission }
      })
    } else {
      next()
    }
  },
  components: {
    "frequency-editor": () => import("./editor")
  },
  data () {
    return {
      condition: {
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20
      },
      meta:{
        loading: false
      },
      searchLoading: false,
      entities: {},
      showEditor: false,
      entity: {}
    };
  },
  computed: {
    ...mapGetters(["permission"])
  },
  methods: {
    page () {
      let _this = this;
      this.meta.loading = true;
      api.Tabu.query(this.condition).then(res => {
        _this.entities = res;
        _this.$utils.log('entities', res)
        _this.meta.loading = false;
      });
    },
    create () {
      this.$set(this, "entity", {});
      this.showEditor = true;
    },
    edit (row) {
      this.$set(this, "entity", JSON.parse(JSON.stringify(row)));
      this.showEditor = true;
    },
    entityUpdated (value) {
      // store.dispatch('loadDicts', value.type)
      this.page();
    },
    sortChanged (col) {
      if (!col.order) {
        this.condition.sort = 'id'
        this.condition.asc = false
      } else {
        this.condition.sort = col.prop
        this.condition.asc = (col.order == "ascending")
      }
      this.page()
    },
    filterChanged (options) {
      Object.assign(this.condition, options);
      this.page()
    },
    applyChanged(){

    },
    del (row, index) {
      let _this = this;
      api.Tabu.del(row.id).then(res => {
        _this.entities.items.splice(index, 1, {});
        _this.$message.success("删除成功！");
      });
    },
  }
};
</script>

<style scoped>
</style>
